export default __webpack_public_path__ + "static/media/FACIL_DE_USAR_ICON.2452c7b3.svg";